export default __webpack_public_path__ + "fonts/disney-icons.svg";